import {
  ControlledCombobox,
  type Option,
} from "~/molecules/ControlledCombobox";
import { BulkEditableCell } from "~/molecules/BulkEditableCell";

interface Props {
  value: string | null;
  onChange: (value: string) => void;
  options: Option[] | undefined;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  highlighted?: boolean;
  onHover?: () => void;
  onHoverLeave?: () => void;
}

export const ComboboxCell = ({
  value,
  onChange,
  options,
  placeholder,
  disabled,
  hasError,
  errorMessage,
  highlighted,
  onHover,
  onHoverLeave,
}: Props) => (
  <BulkEditableCell
    hasError={hasError}
    highlighted={highlighted}
    onHover={onHover}
    onHoverLeave={onHoverLeave}
    errorMessage={hasError ? errorMessage : undefined}
  >
    <ControlledCombobox
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
    />
  </BulkEditableCell>
);
